import { useEffect } from 'react';
import { Outlet, useNavigate, useParams, generatePath } from 'react-router-dom';
import { ButtonPrimary, ButtonSize } from '@ui/src';
import { useAppDispatch, useAppSelector } from '@store';
import { getCards, onCardStatusChange } from '../store/slices/cards/cards';
import Card from '../../../components/partial/card/card';
import CardsList from '../../../components/partial/cards/cards-list';
import CardsTransactions from '../../customers/cards-transactions/list';
import { CustomerType } from '../../customers/types';

import ROUTES from '../../../routes';

import cn from '../information.module.css';

const IndividualCustomerCards = (): React.JSX.Element => {
  const {
    cards: {
      cards,
      isLoading,
      statusChangeInProgress,
      updatedCard,
      changeStatusSuccess,
    },
    general: { baseInformation },
  } = useAppSelector((state) => state.individualCustomers.info);

  const { customerId } = useParams();

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    if (!cards) {
      dispatch(getCards());
    }
  }, [dispatch, cards]);

  useEffect(() => {
    let title =
      baseInformation?.firstName || baseInformation?.lastName
        ? `${baseInformation?.firstName} ${baseInformation?.lastName || ''}: Cards`
        : 'Cards';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, [baseInformation?.firstName, baseInformation?.lastName]);

  let content;

  if (isLoading) {
    content = <Card isLoading={isLoading} />;
  } else if (!isLoading && cards) {
    content = (
      <>
        <ButtonPrimary
          size={ButtonSize.SMALL}
          text="Order a card"
          className={cn.orderCardButton}
          onClick={() =>
            navigate(
              generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_CARDS_ORDER, {
                customerId: customerId as string,
              }),
            )
          }
        />
        <CardsList
          customerId={customerId}
          cards={cards}
          onStatusChange={(data) => dispatch(onCardStatusChange(data))}
          updatedCard={updatedCard}
          statusChangeInProgress={statusChangeInProgress}
          customerType={CustomerType.INDIVIDUAL}
          changeStatusInProgress={statusChangeInProgress}
          changeStatusSuccess={changeStatusSuccess}
        />
        {cards?.length > 0 && (
          <CardsTransactions
            customerType={CustomerType.INDIVIDUAL}
            cards={cards}
          />
        )}
      </>
    );
  }

  return (
    <div>
      {content}
      <Outlet />
    </div>
  );
};

export default IndividualCustomerCards;
